import React from "react";

const HomeIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.07314 6.1116L8.70513 0.547967C8.88065 0.420018 9.1187 0.420018 9.29421 0.547967L16.9262 6.1116C17.3173 6.39669 17.1156 7.01564 16.6317 7.01564H16.3747C16.0985 7.01564 15.8747 7.2395 15.8747 7.51564V13.9999C15.8747 14.2761 15.6508 14.4999 15.3747 14.4999H10.6455C10.3694 14.4999 10.1455 14.2761 10.1455 13.9999V9.63828C10.1455 9.36214 9.92165 9.13828 9.64551 9.13828H8.35384C8.0777 9.13828 7.85384 9.36214 7.85384 9.63828V13.9999C7.85384 14.2761 7.62998 14.4999 7.35384 14.4999H2.62467C2.34853 14.4999 2.12467 14.2761 2.12467 13.9999V7.51564C2.12467 7.2395 1.90082 7.01564 1.62467 7.01564H1.36767C0.883719 7.01564 0.682063 6.39669 1.07314 6.1116Z"
      fill="#30323A"
    />
  </svg>
);

export default HomeIcon;
